import React, { useContext } from 'react'
import { ConfigContext } from './App'
import { signOut } from 'aws-amplify/auth'
import { useNavigate } from 'react-router-dom'

function AccountLogin() {
  let navigate = useNavigate()
  const contextLogin = useContext(ConfigContext)

  if (contextLogin.params.stullerAccount) {
    return (
      <p>
        You are successfully logged in as
        <b> {contextLogin.params.first_name}. </b>
        <span
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={async () => {
            await signOut()
            contextLogin.resetContext()
            navigate(0)
          }}
        >
          (Log out)
        </span>
      </p>
    )
  } else {
    return (
      <div>
        <p>
          Are you a current Stuller customer? &nbsp;
          <a
            href={
              !document.location.hostname.includes('localhost')
                ? `https://gemvision.com/login/?getBack=${document.baseURI}`
                : `http://localhost:3000/login/?getBack=${document.baseURI}`
            }
            title='Gemvision Login'
          >
            Log in
          </a>
        </p>
      </div>
    )
  }
}

export default AccountLogin
